import { BoxLogItem, BoxDetailLogProps } from '@/box/interface'
import { getFormatMessage } from '@/utils/utils'
import { Table } from 'antd'
import moment from 'moment'
import React from 'react'

export const BoxDetailLog: React.FC<BoxDetailLogProps> = (
  props: BoxDetailLogProps
) => {
  const formatMessage = getFormatMessage()
  const columns = [
    {
      title: formatMessage({ id: 'app.box.detail.logs.index' }),
      key: 'app.box.detail.logs.index',
      render: (text: any, record: any, index: any) => index + 1
    },
    {
      title: formatMessage({ id: 'app.box.detail.logs.content' }),
      key: 'app.box.detail.logs.content',
      render: (text: any, record: BoxLogItem, index: any) => {
        return formatMessage({
          id: `app.box.detail.logs.action.${record.action}`
        })
      }
    },
    {
      title: formatMessage({ id: 'app.box.detail.logs.timestamp' }),
      key: 'app.box.detail.logs.timestamp',
      render: (text: any, record: BoxLogItem, index: any) => {
        return moment(record.timestamp).local().format('YYYY-MM-DD HH:mm:ss')
      }
    }
  ]

  return (
    <Table
      rowKey='id'
      columns={columns}
      dataSource={props.data}
      pagination={props.pagination}
    />
  )
}
